import { cn } from "@newxsystems/shared";
import { HeroCentered } from "../../../../modules/content/components/HeroCentered/HeroCentered";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { getKaajSectionSpacing } from "../../../../modules/layout/kaaj-section-spacing";
import type { IHeroBlockProps } from "./HeroBlock.props";

const sectionThemeClass = "text-[#151927]";

export const HeroBlock = (props: IHeroBlockProps) => {
  const { parentClass } = props;
  const variant = props.variant;
  const isBackgroundImage = variant === "background-image";

  if (
    !variant ||
    (!props.eyebrow &&
      !props.heading &&
      !props.subheading &&
      !props.buttons?.length &&
      !props.image?.defaultSrc)
  ) {
    return null;
  }

  return (
    <section
      id={props.anchorId ?? undefined}
      className={cn(
        "relative overflow-hidden",
        sectionThemeClass,
        isBackgroundImage
          ? "py-0 md:flex md:h-[min(42rem,80vh)] md:flex-col md:justify-center lg:h-[min(60rem,80vh)]"
          : getKaajSectionSpacing(props.spacing),
        parentClass,
      )}
    >
      {isBackgroundImage ? (
        <HeroBackgroundImage {...props} />
      ) : (
        <div className="kaaj-container relative">
          {variant === "split-image" ? <HeroSplitImage {...props} /> : <HeroCentered {...props} />}
        </div>
      )}
    </section>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
